//Add same colors from colors.scss here if need
const Colors = {
  primaryGreen: '#14452f',
  lightCream: '#efefe9',
  darkCharcoal: '#221f1f',
  lightGray: '#d9d9d9',
  toxicGreen: '#A9E24E',

  //Default colors
  white: '#ffffff',
  black: '#000000',
};

export default Colors;
